import { render, staticRenderFns } from "./imgsettings.vue?vue&type=template&id=4cdb18f7"
import script from "./imgsettings.vue?vue&type=script&lang=js"
export * from "./imgsettings.vue?vue&type=script&lang=js"
import style0 from "./imgsettings.vue?vue&type=style&index=0&id=4cdb18f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports